import { Alert, type AlertProps, AlertIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { DoffinNoAnswer } from "./doffinNoAnswer";

export const DoffinNoAnswerAlert = ({
  noAnswer,
  ...alertProps
}: { noAnswer: DoffinNoAnswer } & AlertProps) => {
  const { t } = useTranslation();
  return (
    <Alert
      status={noAnswer === "whileSending" ? "warning" : "error"}
      alignItems="start"
      {...alertProps}
    >
      <AlertIcon />
      {noAnswer === "whileSending"
        ? t("zz_DoffinApiErrorCode_DoffinDidNotAnswerWhileSending")
        : t("zz_DoffinApiErrorCode_DoffinDidNotAnswerNothingSent")}
    </Alert>
  );
};
